import React, { useState } from "react";
import "./Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo1.svg";

import Booking from "../Components-2/Booking";       // Import your Booking form
import ModalWrapper from "../Components-2/ModalWrapper"; // Import modal

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false); // modal state
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMobileMenu = () => {
    setMenuOpen(false);
  };

  // Scroll if already on home page
  const handleScroll = (id) => {
    if (location.pathname === "/") {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
      closeMobileMenu();
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo */}
          <Link to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" className="logo" />
          </Link>

          {/* Menu Links */}
          <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link to="/" onClick={() => handleScroll("home")}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/" onClick={() => handleScroll("services")}>
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/" onClick={() => handleScroll("team")}>
                Team
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/" onClick={() => handleScroll("sublime")}>
                Top Works
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/" onClick={() => handleScroll("footer")}>
                Contact Us
              </Link>
            </li>
          </ul>

          {/* Right Side */}
          <div className="right-items">

            <button className="book-btn" onClick={() => setOpenModal(true)}>
              Book a Session
            </button>


            <div className="menu-icon" onClick={toggleMobileMenu}>
              {menuOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>
        </div>
      </nav>
      <ModalWrapper show={openModal} onClose={() => setOpenModal(false)}>
        <Booking />
      </ModalWrapper>
    </>
  );
};

export default Navbar;
